exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */\n/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */.flexbox-button-vma{box-sizing:content-box;list-style:none;display:-ms-flexbox;display:flex;height:31px;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center;-ms-flex-wrap:nowrap;flex-wrap:nowrap}[dir] .flexbox-button-vma{padding-top:11px;border:1px solid #97999b;cursor:pointer}[dir=ltr] .flexbox-button-vma{padding-left:15px;padding-right:15px;margin-left:25px}[dir=rtl] .flexbox-button-vma{padding-right:15px;padding-left:15px;margin-right:25px}@media (max-width:767px){[dir] .flexbox-button-vma{padding:0;margin:0;padding-top:11px}[dir=ltr] .flexbox-button-vma,[dir=rtl] .flexbox-button-vma{margin-right:15px;margin-left:15px}}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/view-my-account/view-my-account.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/view-my-account/view-my-account.component.scss
// module chunks = 0